(function () {
  if (customElements.get('product-card-inline-picker')) return;

  class ProductCardInlinePicker extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-inline-picker-panel]');
      this.openButton = this.querySelector('[data-inline-picker-open]');
      this.closeButton = this.querySelector('[data-inline-picker-close]');
      this.selects = Array.from(this.querySelectorAll('[data-inline-picker-option]'));
      this.price = this.querySelector('[data-inline-picker-price]');
      this.status = this.querySelector('[data-inline-picker-status]');
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('input[name="id"]');
      this.addButton = this.querySelector('[data-inline-picker-add]');
      this.variants = this.readVariants();

      if (!this.panel || !this.openButton || !this.form || !this.variantInput) return;

      this.stopCarouselEvents(this.panel);
      this.openButton.addEventListener('click', this.open.bind(this));
      this.closeButton && this.closeButton.addEventListener('click', this.close.bind(this));
      this.selects.forEach((select) => select.addEventListener('change', this.update.bind(this)));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
      this.update();
    }

    readVariants() {
      const script = this.querySelector('[data-inline-picker-variants]');
      if (!script) return [];
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error('Inline variant picker data could not be read.', error);
        return [];
      }
    }

    stopCarouselEvents(element) {
      ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach((eventName) => {
        element.addEventListener(eventName, (event) => event.stopPropagation());
      });
    }

    open(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.openButton.disabled) return;
      this.setAttribute('open', '');
      this.panel.hidden = false;
      this.openButton.setAttribute('aria-expanded', 'true');
      this.update();
      if (this.selects[0]) this.selects[0].focus({ preventScroll: true });
    }

    close(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.removeAttribute('open');
      this.panel.hidden = true;
      this.openButton.setAttribute('aria-expanded', 'false');
      this.openButton.focus({ preventScroll: true });
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && !this.panel.hidden) this.close(event);
    }

    update() {
      if (!this.variants.length || !this.selects.length) return;

      const selected = [];

      this.selects.forEach((select, index) => {
        const compatible = this.variants.filter((variant) => {
          if (!variant.available) return false;
          return selected.every((value, priorIndex) => variant.options[priorIndex] === value);
        });
        const allowed = new Set(compatible.map((variant) => variant.options[index]));

        Array.from(select.options).forEach((option) => {
          option.disabled = !allowed.has(option.value);
        });

        if (!allowed.has(select.value)) {
          const firstAllowed = Array.from(select.options).find((option) => !option.disabled);
          if (firstAllowed) select.value = firstAllowed.value;
        }

        selected.push(select.value);
      });

      const match = this.variants.find((variant) => {
        return variant.available && variant.options.every((value, index) => value === selected[index]);
      });

      if (!match) {
        this.addButton.disabled = true;
        this.status.textContent = 'This combination is unavailable.';
        this.price.textContent = '';
        return;
      }

      this.variantInput.value = String(match.id);
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.addButton.disabled = false;
      this.status.textContent = '';
      this.price.textContent = match.price || '';
    }
  }

  customElements.define('product-card-inline-picker', ProductCardInlinePicker);
})();